import { getImgUrl } from 'features/imagesStore/utils/adapter';
import { adapterTimePricing } from 'features/timesPrice';

import {
  CourtInfo,
  CourtInfoServer,
  CourtsListServer,
  CourtsList,
} from '../store/types';

export const adapteCourtInfo = ({ surface_type, metainfo, image_id, ...res }: CourtInfoServer): CourtInfo => ({
  ...res,
  surfaceType: surface_type,
  imageId: image_id,
  imageUrl: getImgUrl(image_id),
  metainfo: {
    pricing: adapterTimePricing(metainfo.pricing)
  }
});

export const adapteCourtsList = (courts: CourtsListServer): CourtsList => courts.map(adapteCourtInfo).sort((a, b) => a.id - b.id);
